import APIEmployees from '@/api/modules/employees';
import Cookies from 'js-cookie';

const initialState = {
  canManageEmployees: false,
  permissionVersion: 0,
};

export default {
  namespaced: true,
  state: initialState,
  mutations: {
    RESET_PERMISSIONS(state) { state.permissionVersion++; state.canManageEmployees = false; },
    SET_DATA(state, { type, data }) {
      state[type] = data;
    },
  },
  actions: {
    async refreshPermissions({ commit, state }) {
      const version = state.permissionVersion + 1;
      commit('SET_DATA', { type: 'permissionVersion', data: version });
      commit('SET_DATA', { type: 'canManageEmployees', data: false });
      // A token refresh can finish inside the API call. Resolve permission again
      // for that token so the old response cannot grant or hide editing rights.
      for (let attempt = 0; attempt < 2; attempt++) {
        const token = Cookies.get('adminToken');
        if (!token || version !== state.permissionVersion) return;
        try {
          const allowed = await APIEmployees.getPermissions();
          if (version !== state.permissionVersion) return;
          if (token === Cookies.get('adminToken')) {
            commit('SET_DATA', { type: 'canManageEmployees', data: allowed });
            return;
          }
        } catch (e) {
          if (version !== state.permissionVersion || token === Cookies.get('adminToken')) return;
        }
      }
    },
  },
};
